<template>
  <div class="express-center-box express-center-box1" :class="{'showLeftMenu': showLeftMenu}">
    <img src="../../assets/img/qiwang/home.png" alt="">
    <div class="content-title">
      <div translate="no"  class="title1">iTMS</div>
      <div translate="no" class="title2">{{ $t('home.index.925578-0') }}</div>
      <div translate="no" class="title3">WELCOME TO iTMS</div>
    </div>
    <!-- <h1>{{ $t('welcomeHomePage') }}</h1> -->
  </div>
</template>
<script>
import { SappModule } from '@/store/modules/app'

export default ({
  name: 'Index',
  computed: {
    showLeftMenu() {
      return SappModule.sidebar.opened
    }
  },
  mounted() {
    this.$nextTick(() => {
      const imgView = document.querySelector('.express-center-box')
      if (imgView) {
        if (this.$route.path === '/' || this.$route.path === '' || this.$route.path === '/home/welcome') {
          imgView.setAttribute('style', 'margin-left:100px;')
        } else {
          imgView.setAttribute('style', 'margin-left:0px;')
        }
      }
    })
    this.adjustContentTitleScale()
    // 在页面加载时初始化一次
    window.addEventListener('load', this.adjustContentTitleScale)

    // 监听窗口大小变化
    window.addEventListener('resize', this.adjustContentTitleScale)
  },
  methods: {
    adjustContentTitleScale() {
      const contentTitles = document.querySelectorAll('.content-title')
      const viewportWidth = window.innerWidth

      if (viewportWidth > 1188) {
        contentTitles.forEach(title => {
          title.style.transform = 'scale(1)'
          title.style.left = '12.29%'
        })
      } else {
        const scaleRatio = viewportWidth / 1188
        contentTitles.forEach(title => {
          title.style.transform = `scale(${scaleRatio})`
          title.style.left = `${12.29 * scaleRatio}%`
        })
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import './index.scss';
.express-center-box{
  margin-top: 0px;
  background: #fff;
  height: calc(100vh - 105px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 55px;
  flex-direction: column;
  margin-left: 0 !important;
  transition: margin-left .28s;
  width: calc(100vw - 0px - 32px) !important;
  img{
    width: 500px;
  }
  &.express-center-box1 {
    margin-left: 0 !important;
    width: calc(100vw - 0px) !important;
    height: 100%;
    overflow: hidden;
    position: relative;
    &.showLeftMenu{
      width: calc(100vw - 236px) !important;
      margin-left: 236px !important;
    }
    img{
      width: 100%;
      height: calc(100vh - 146px);
      overflow: hidden;
      object-fit: cover;
    }
    .content-title{
      position: absolute;
      top: 38.82%;
      left: 12.29%;
      .title1{
        height: 66px;
        line-height: 66px;
        font-size: 60px;
        font-family: JINGDONGLangZhengTi1;
        color: rgba(60,110,240,1);
      }
      .title2{
        margin-top: 4px;
        height: 66px;
        line-height: 66px;
        font-size: 60px;
        font-family: JINGDONGLangZhengTi1;
        color: rgba(35,37,43,1);
      }
      .title3{
        line-height: 18px;
        height: 18px;
        font-size: 16px;
        font-family: JINGDONGLangZhengTi1;
        color: rgba(134,141,159,1);
        margin-top: 4px;
      }
    }
  }
}
</style>
